<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addDataParkHonor" v-if="permissionCodes.indexOf('034008001') !== -1"/>
        <!--<button-delete @deleteSelection="deleteSelection" />-->
      </div>
      <input-search placeholder="规则名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该班次？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/AttendancePoint'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb
    },
    name: 'attendance-frequency-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '班次管理'
        }],
        addDataParkHonor: 'attendance-frequency-add',
        operationArr: ['modify', 'delete'],

        tableHead: [{
          prop: 'name',
          label: '班次名称'
        }, {
          prop: 'shortName',
          label: '班次简称'
        }, {
          prop: 'checkInTime',
          label: '上班打卡时间'
        }, {
          prop: 'checkOutTime',
          label: '下班打卡时间'
        }],
        tableData: [],
        total: 0,
        selectionArr: [],
        requestData: {
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
        },
        dialogFormVisible: false,
        videoInfo: {}
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      getPage () {
        this.$axios.post(api.getAttendanceClassPage, this.requestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {})
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.requestData.pageNum = data[0]
        this.requestData.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        this.$router.push({
          path: '/attendance_frequency_modify/' + code
        })
      },

      deleteLine (code) {
        this.$axios.post(api.deleteAttendanceClassByCodes, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      }
    },
    watch: {
      centEndTime(val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .form-line {
    width: 420px;
    margin: 20px auto;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceFrequency/AttendanceFrequencyManage.vue